import { render, staticRenderFns } from "./OpsPhone.vue?vue&type=template&id=4fc6a53d&scoped=true"
import script from "./OpsPhone.vue?vue&type=script&lang=js"
export * from "./OpsPhone.vue?vue&type=script&lang=js"
import style0 from "./OpsPhone.vue?vue&type=style&index=0&id=4fc6a53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc6a53d",
  null
  
)

export default component.exports